module.exports = __webpack_public_path__ + "img/USDC.9bfd64df.svg";